import Phaser from 'phaser';

const MIN_SVG_RESOLUTION = 2;
const MAX_SVG_TEXTURE_SCALE = 8;
const SVG_OVERSAMPLE = 1.5;
const TEXTURE_SIZE_SAFETY_MARGIN = 0.95;

type SvgAssetSize = {
	width: number;
	height: number;
};

function getViewportWidth(): number {
	return Math.max(1, Math.round(window.innerWidth || 1));
}

function getMaxTextureSize(scene: Phaser.Scene): number | undefined {
	if (scene.game.renderer.type !== Phaser.WEBGL) {
		return undefined;
	}

	return (scene.game.renderer as Phaser.Renderer.WebGL.WebGLRenderer).getMaxTextureSize();
}

export function getSvgTextureSize(
	scene: Phaser.Scene,
	assetSize: SvgAssetSize,
): Phaser.Types.Loader.FileTypes.SVGSizeConfig {
	const safeViewportWidth = getViewportWidth();
	const safeDevicePixelRatio = Math.max(MIN_SVG_RESOLUTION, window.devicePixelRatio || 1);
	const maxTextureSize = getMaxTextureSize(scene);
	const targetWidth = safeViewportWidth * safeDevicePixelRatio * SVG_OVERSAMPLE;
	const maxScaleByTextureSize = maxTextureSize
		? Math.min(
				(maxTextureSize * TEXTURE_SIZE_SAFETY_MARGIN) / assetSize.width,
				(maxTextureSize * TEXTURE_SIZE_SAFETY_MARGIN) / assetSize.height,
		  )
		: Number.POSITIVE_INFINITY;
	const textureScale = Math.min(
		MAX_SVG_TEXTURE_SCALE,
		maxScaleByTextureSize,
		Math.max(1, targetWidth / assetSize.width),
	);

	return {
		width: Math.ceil(assetSize.width * textureScale),
		height: Math.ceil(assetSize.height * textureScale),
	};
}
